import { BehaviorScreen } from './screen.type';

export class ResetMonitorImageResolutionViewModel {
    MonitorHandlers: string[];
    MachinePhysicalAddress: string;

    constructor(monitor: BehaviorScreen) {
        this.MachinePhysicalAddress = monitor.MachinePhysicalAddress;
        this.MonitorHandlers = [monitor.MonitorHandler];
    }
}
